module.exports = {
      id: "comm-lifestyle-usage",
      viewBox: "0 0 294 59.387",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-lifestyle",
      toString: function () {
        return this.url;
      }
    }